import { useState, useEffect, useRef, useCallback } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { captchaStyle } from "./CaptchaGateStyles";
import { verifyCaptcha } from "./service";
import { showNotification } from "../common/notifications/notifications";

const DELAY = 1500;

const CaptchaGate = ({ onVerified }) => {
    const [isVisible, setIsVisible] = useState(false);
    const reCaptchaRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), DELAY);
        return () => clearTimeout(timer);
    }, []);

    const showCaptchaError = (message) => {
        showNotification({notificationType: 'SHOW_CAPTCHA_ERROR', orderedMessage: message}); 
    };

    const handleChange = useCallback(async (token) => {
        if (!token) return;

        try {
            const { isVerify } = await verifyCaptcha(token);

            if (isVerify) {
                onVerified();
            } else {
                showCaptchaError("CAPTCHA failed. Please try again.");
            }
        } catch (error) {
            console.error("Error verifying CAPTCHA:", error);
            showCaptchaError("Error verifying CAPTCHA. Please try again.");
        }
    }, [onVerified]);

    return (
        <div className="container-fluid py-2">
            <div className="row">
                <div className="col-lg-8 col-md-10 mx-auto">
                    <div className="card mt-4">
                        <div className="card-header p-3">
                            <h5 className="mb-0">Please complete the security check to access registration.instafix.co.uk</h5>
                        </div>
                        <div className="card-body p-3 pb-0">
                            <div className="mb-8 mt-5 justify-content-center" style={captchaStyle}>
                                {isVisible && (
                                    <ReCAPTCHA
                                        ref={reCaptchaRef}
                                        sitekey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                                        theme="dark"
                                        onChange={handleChange}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-12 col-md-6 col-xl-6 position-relative">
                                <div className="card card-plain h-100">
                                    <div className="card-header pb-0 p-3">
                                        <h5 className="mb-0">Why do I have to complete a CAPTCHA?</h5>
                                    </div>
                                    <div className="card-body p-3">
                                        <p className="text-sm">
                                            Completing the CAPTCHA proves you are a human and gives you temporary access to the web property.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-xl-6 mt-md-0 mt-4 position-relative">
                                <div className="card card-plain h-100">
                                    <div className="card-header pb-0 p-3">
                                        <h5 className="mb-0">What can I do to prevent this in the future?</h5>
                                    </div>
                                    <div className="card-body p-3">
                                        <p className="text-sm">
                                            If you are on a personal connection, like at home, you can run an anti-virus scan on your device to make sure it is not infected with malware.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CaptchaGate;